import posthog from "posthog-js";

// Enquanto REACT_APP_POSTHOG_KEY não estiver configurada, todas as funções
// abaixo viram no-op silencioso — mesmo padrão já usado para SMTP neste repo:
// a integração só liga de verdade quando a env var é preenchida.
let isInitialized = false;

export function initAnalytics() {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    // capture_pageview e autocapture ficam desligados de propósito: só rastreamos
    // os eventos explícitos que instrumentarmos, não tudo automaticamente.
    capture_pageview: false,
    autocapture: false,
  });
  isInitialized = true;
}

export function identifyUser(user) {
  if (!isInitialized || !user) return;
  posthog.identify(String(user.id), { email: user.email });
}

export function resetAnalytics() {
  if (!isInitialized) return;
  posthog.reset();
}

export function trackEvent(name, properties) {
  if (!isInitialized) return;
  posthog.capture(name, properties);
}
